import { render, staticRenderFns } from "./InformationForm.vue?vue&type=template&id=cd317c44&scoped=true"
import script from "./InformationForm.vue?vue&type=script&lang=js"
export * from "./InformationForm.vue?vue&type=script&lang=js"
import style0 from "./InformationForm.vue?vue&type=style&index=0&id=cd317c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd317c44",
  null
  
)

export default component.exports